import React, { useState, useEffect, useRef } from "react";
import "./Header.scss";
import logo from "../../assets/litter_intelligence_logo.svg";

export const Header: React.FC<{}> = () => {

  const headerRef = useRef(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  useOnClickOutside(headerRef, () => setIsOpen(false));

  return (
    <header ref={headerRef}>
      <a href="https://litterintelligence.org/" rel="noopener noreferrer">
        <img src={logo} alt="Litter Intelligence — Home" className="logo" />
      </a>

      <button className="hamburger_button" onClick={() => setIsOpen(!isOpen)}>
        <span className={`${isOpen ? 'hamburger_icon__open' : 'hamburger_icon__closed'}`}> 
          <span className="hamburger_icon__bar"></span>
        </span>
      </button>
      
      <div className={`${isOpen ? 'header_page_link_container__open' : 'header_page_link_container__closed'}`}>
        <a href="https://litterintelligence.org/data/" rel="noopener noreferrer">
          Data
        </a>
        <a className="active" style={{cursor: "pointer"}}>
          Insights
        </a>
        <a href="https://litterintelligence.org/action/" rel="noopener noreferrer">
          Action
        </a>
        <a href="https://litterintelligence.org/education/" rel="noopener noreferrer">
          Education
        </a>
        <a href="https://litterintelligence.org/about/" rel="noopener noreferrer">
          About
        </a>
        <a href="https://app.litterintelligence.org" rel="noopener noreferrer" className="login_button">
          Log In
        </a>
      </div>
    </header>
  );
};


//Custom hook for listening to outside click events
function useOnClickOutside(ref: any, handler: any) {
  useEffect(() => {
    const listener = (event: any) => {
      // Do nothing if clicking ref's element or descendent elements
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      handler(event);
    };

    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);

    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, handler]);
}
